export enum NotificationHeaderType {
  ServiceAppointment = 'ServiceAppointment',
  AutoActivatedBySMm = 'AutoActivatedBySMm',
  FinalPayment = 'FinalPayment',
  Birthday = 'Birthday',
  Anniversary = 'Anniversary',
  MdlServiceArrival = 'MdlServiceArrival',
  EmailCampaignClick = 'EmailCampaignClick',
  AssignedDeal = 'AssignedDeal',
  PrivateIncentive = 'PrivateIncentive',
  Showroom = 'Showroom',
  All = '',
  WebsiteActivity = 'WebsiteActivity',
}

export enum NotificationType {
  ServiceAppointment = 'ServiceAppointment',
  AutoActivatedBySMm = 'AutoActivatedBySMm',
  FinalPayment = 'FinalPayment',
  Birthday = 'Birthday',
  Anniversary = 'Anniversary',
  MdlServiceArrival = 'MdlServiceArrival',
  EmailCampaignClick = 'EmailCampaignClick',
  AssignedDeal = 'AssignedDeal',
  PrivateIncentive = 'PrivateIncentive',
  ConquestCampaignClick = 'ConquestCampaignClick',
  CampaignQrCodeScan = 'CampaignQrCodeScan',
  CampaignUrlClick = 'CampaignUrlClick',
  AssignedMarketConquestDeal = 'AssignedMarketConquestDeal',
  ShowroomUrlQrCodeScan = 'ShowroomUrlQrCodeScan',
  ShowroomUrlClicked = 'ShowroomUrlClicked',
  ShowroomOfferSubmitted = 'ShowroomOfferSubmitted',
  ShopperActivityWebsiteVisit = 'ShopperActivityWebsiteVisit',
  ShopperActivityVehicleViewed = 'ShopperActivityVehicleViewed',
  ShopperActivityLeadSubmitted = 'ShopperActivityLeadSubmitted',
}
